import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountPPICloseInfoPage} from '../../../../../../../features/credit/pages/CreditAccountPPIClosePage/CreditAccountPPICloseInfoPage';

export const Route = createFileRoute(
  '/_protected/accounts/credits/$accountId/ppi/close/',
)({
  component: CreditAccountPPICloseInfoPage,
});
